import { Alert, Button, Descriptions, Empty, Skeleton, Tag, Tooltip, Typography } from 'antd'
import { useEffect, useState } from 'react'
import { getSitePublishStatus } from '../api'
import type { PublishStatus } from '../types'
import { useWorkspaceState } from './WorkspaceContext'

// Spec §29/§30 — only reads Phase 2A-5's existing ActivationPointer
// result; never builds a fake Snapshot to make the button clickable.
// The real Publish button ships in Phase 2B-2/2B-3.
export default function WorkspacePublishPage() {
  const { primarySite, sites } = useWorkspaceState()
  const [status, setStatus] = useState<PublishStatus | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!primarySite) return
    getSitePublishStatus(primarySite.id)
      .then((r) => setStatus(r.data))
      .catch((err) => setError(err.message))
  }, [primarySite])

  if (sites.length === 0 || !primarySite) {
    return <Empty description="No sites in this workspace yet" style={{ marginTop: 80 }} />
  }

  return (
    <div>
      <Typography.Title level={4}>Publish</Typography.Title>
      {error && <Alert type="error" message={error} showIcon style={{ marginBottom: 16 }} />}
      {status === null ? (
        <Skeleton active paragraph={{ rows: 4 }} />
      ) : (
        <>
          <Descriptions bordered column={1} size="small" style={{ maxWidth: 600, marginBottom: 24 }}>
            <Descriptions.Item label="Current Revision">{status.revision_id ?? '—'}</Descriptions.Item>
            <Descriptions.Item label="Last Publish Status">
              {status.has_publish ? <Tag color="green">Published</Tag> : <Tag>No publish yet</Tag>}
            </Descriptions.Item>
            <Descriptions.Item label="Content Version">{status.content_version ?? '—'}</Descriptions.Item>
            <Descriptions.Item label="Package Checksum (Shell Hash)">{status.package_checksum ?? '—'}</Descriptions.Item>
            <Descriptions.Item label="Rolled Back">
              <Tag color={status.rolled_back ? 'red' : 'default'}>{status.rolled_back ? 'Yes' : 'No'}</Tag>
            </Descriptions.Item>
            {!status.has_publish && (
              <Descriptions.Item label="Message">
                <Typography.Text type="secondary">{status.message}</Typography.Text>
              </Descriptions.Item>
            )}
          </Descriptions>
          <Tooltip title="Content Runtime not configured — real publishing ships in a later phase">
            <Button disabled>Publish</Button>
          </Tooltip>
        </>
      )}
    </div>
  )
}
